function RetouchBatchSavePanel({ photos, open, onClose, copy }) {
    if (!open || !photos?.length) {
        return null;
    }

    return (
        <div className="retouch-batch-save" role="dialog" aria-modal="true" aria-label={copy.downloadAllMobileTitle}>
            <header className="retouch-batch-save__header">
                <div>
                    <h2 className="retouch-batch-save__title">{copy.downloadAllMobileTitle}</h2>
                    <p className="retouch-batch-save__intro">{copy.downloadAllMobileHint}</p>
                    <p className="retouch-batch-save__count">{copy.downloadAllMobileCount.replace("{count}", photos.length)}</p>
                </div>
                <button type="button" className="retouch-batch-save__close" onClick={onClose} aria-label={copy.closePreview}>
                    ×
                </button>
            </header>
            <div className="retouch-batch-save__list">
                {photos.map((photo, index) => (
                    <article key={photo.id} className="retouch-batch-save__item">
                        <p className="retouch-batch-save__item-meta">
                            {index + 1} / {photos.length} · {photo.relativePath}
                        </p>
                        <div className="retouch-batch-save__image-wrap">
                            <img src={photo.url} alt="" draggable={false} loading="eager" decoding="async" className="retouch-batch-save__image"/>
                        </div>
                        <p className="retouch-batch-save__item-hint">{copy.downloadAllMobileHint}</p>
                    </article>
                ))}
            </div>
        </div>
    );
}

export default RetouchBatchSavePanel;
